import { Field, Form, Formik } from 'formik'
import React from 'react'
import InputField from '../form/fields/input'
import { RequestButton } from '../request-components/request-components'
import { useUpdateMutation } from '../../queries/period-summaries'
import { PeriodSummary } from '../../api/period-summaries'

interface PreBillingEditFormProps {
  preBilling: PeriodSummary
  /**
   * Called once the update mutation settles successfully.
   * Used by the parent to close the modal hosting this form.
   */
  onSuccess?: () => void
}

const PreBillingEditForm: React.FC<PreBillingEditFormProps> = ({ preBilling, onSuccess }) => {
  const updateMutation = useUpdateMutation()

  return (
    <Formik
      initialValues={preBilling}
      enableReinitialize
      onSubmit={values => {
        updateMutation.mutate(
          { invoiceRef: values.invoiceRef, id: preBilling._id.toString() },
          { onSuccess: () => onSuccess?.() },
        )
      }}
    >
      {() => {
        return (
          <Form autoComplete="off">
            <Field label="Numéro de facture" name="invoiceRef" component={InputField} required />
            <RequestButton
              color="primary"
              type="submit"
              mutation={updateMutation}
              data-test="pre-billing-edit-invoice-ref-submit"
            >
              Modifier
            </RequestButton>
          </Form>
        )
      }}
    </Formik>
  )
}
export default PreBillingEditForm
